import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpUtilityService } from "src/app/http/http-utility.service";
import { Login } from './../model/login';
import { User } from './../model/user'
import { AzureAuthUrl, AppId, IsDebugMode } from  "src/environments/environment";
import { Router } from '@angular/router';
import { StoreService } from "src/app/services/store.service";
import { tap } from "rxjs/internal/operators/tap";


/** A service to authenticate a user. */
@Injectable()
export class AuthService {

  private _userKey: string = 'CURRENT_USER';
  private _tokenId: string = 'TOKENID';
  private _sessionState: string = 'DAAPPSESSIONSTATE';
  
  private _user: User;
  

  /** Gets the current user. */
  public get currentUser(): User {
    if (this._user == undefined || this._user === User.noUser) {

      let o = this._storeService.getObject(this._userKey);
      if (o == undefined) {
        return User.noUser;
      }
      this._user = JSON.parse(o);
    }

    return this._user;
  }

  /**
   * Gets a value to determine whether a user is logged in. [True] if logged in; [False] otherwise.
   */
  public get isLoggedIn(): boolean {
    let o = this.currentUser;
    return o !== User.noUser;
  }

  /**
   * Instantiates a AuthService instance.
   * @param {StoreService}        _storeService - An StoreService instance.
   * @param {HttpUtilityService}  _httpUtility  - An HttpUtilityService instance.
   */
  constructor(
    private _router: Router,
    private readonly _httpUtility: HttpUtilityService,
    private _storeService: StoreService) {
  }


  /**
   * Allows access to the application after the user is authenticated.
   * @param   {Login}               login - The users login information.
   * @returns {Observable<User>}
   * - Returns an observable instance that resolves whether a user is logged in.
   */
  public login(login: Login): Observable<boolean> {

    if (login == undefined) { return of(false); }

    let that = this;
    let dto: any = { Username: btoa(login.username), Password: btoa(login.password) };

    return this._httpUtility.post('auth/authenticate', dto)
      .pipe(tap((userDto: any) => {
        if (userDto == undefined || userDto.UserId === 0) {
          that._user = User.noUser;
          return false;
        }

        that._user = {
          userId: userDto.UserId,
          userName: userDto.Username,
          firstName: userDto.FirstName,
          lastName: userDto.LastName
        };

      //  that._storeService.setObject(that._userKey, that._user);

        return that.isLoggedIn;
      }));
  }

  /**
   * Removes access and logs a user out of the application.
   */
  public logout(): void {
    this._user = User.noUser;
    this._router.navigate(['/logout']);
    this.clearAllSession();
  }

 /**
   * Gets the getredirecturl for the application.
  */
   public getredirecturl(apptoken: string): Observable<string> {

      var data = { "daappsessionstate": apptoken, "appid": AppId, "action": "authurl" , "isdebugmode": IsDebugMode};
      console.log("Request Data::::"+data);
      return this._httpUtility.externalpost(AzureAuthUrl, data)
          .pipe(url => url);
  } 

  /**
   * Authenticate user
  */
  public getauthuser(authcode: string, sessionstate: string): Observable<any> {

      var data = { "authorizationcode": authcode, "azuresessionstate": sessionstate, "daappsessionstate": this.getdaappsessionstate(), "appid": AppId, "action": "getuser", "isdebugmode": IsDebugMode};
      return this._httpUtility.externalpost(AzureAuthUrl, data)
          .pipe(result => result);
  } 

 /**
   * stores the daappsessionstate value from browser session storage
  */
  public renewtoken(): Observable<any> {

      var data = { "daappsessionstate": this.getdaappsessionstate(), "tokenId": this.gettokenid(), "appid": AppId, "action": "renewtoken", "isdebugmode": IsDebugMode };
      return this._httpUtility.externalpost(AzureAuthUrl, data)
          .pipe(result => result);
  } 

  /**
   * Reads the daappsessionstate value from browser session storage
  */
  public getdaappsessionstate():any {
    return this._storeService.getObject(this._sessionState);
  }

  /**
   * stores the daappsessionstate value from browser session storage
  */
  public setdaappsessionstate(value:any):void {
      this._storeService.setObject(this._sessionState,value); 
  }

  /**
   * stores the tokenid value from browser session storage
  */
  public settokenid(data: any):void {
      this._storeService.setObject(this._tokenId, data);
  }

 /**
  * stores the tokenid value from browser session storage
 */
 public gettokenid():any {
     return this._storeService.getObject(this._tokenId);
 }

 public setCurrentUser(user:any):void {
    this._storeService.setObject(this._userKey, user);
 }


 public clearAllSession() {
   this._storeService.removeItem(this._tokenId);
   this._storeService.removeItem(this._sessionState);
   this._storeService.removeItem(this._userKey);
   this._storeService.clear();
   // sessionStorage.clear();
   //localStorage.clear();
  }

}
